'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 34 28',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement(
                'g',
                { fill: 'none', fillRule: 'evenodd', stroke: 'none', strokeWidth: '1' },
                _react2.default.createElement('path', {
                    d: 'M31.733 19.623h.128v.312h.06v-.312h.137v-.064h-.325zM32.34 19.827l-.115-.268h-.098v.376h.07v-.285l.107.244h.074l.107-.244v.285h.068v-.376h-.098z',
                    fill: '#F79E1B'
                }),
                _react2.default.createElement('path', {
                    d: 'M18.588 7.965a9.764 9.764 0 0 0-1.657-1.628h-.004l.004.003a9.591 9.591 0 0 0-3.761 7.602 9.591 9.591 0 0 0 3.757 7.602h.004c4.275-3.3 5.017-9.38 1.657-13.579',
                    fill: '#FF5F00'
                }),
                _react2.default.createElement('path', {
                    d: 'M13.17 13.942c-.003-2.967 1.384-5.77 3.76-7.602l-.003-.003C12.651 3.04 6.464 3.77 3.105 7.967c-3.36 4.2-2.618 10.28 1.658 13.58a9.988 9.988 0 0 0 12.168 0l-.004-.003a9.591 9.591 0 0 1-3.757-7.602',
                    fill: '#EB001B'
                }),
                _react2.default.createElement('path', {
                    d: 'M16.93 6.337a9.744 9.744 0 0 1 1.658 1.628c3.36 4.2 2.618 10.279-1.657 13.579a9.961 9.961 0 0 0 6.085 2.068c5.438 0 9.846-4.33 9.846-9.67v-.003a9.56 9.56 0 0 0-2.106-5.976c-3.36-4.199-9.55-4.927-13.825-1.626',
                    fill: '#F79E1B'
                })
            )
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: null,
    width: '34px',
    height: '28px'
};

Icon.displayName = 'ProductMasterCardWhite';

exports.default = Icon;